import styled from 'styled-components'

const ItemRowCard = styled.div`
  font-family: Roboto;
  margin: 0;
`
export default ItemRowCard
